import { render, staticRenderFns } from "./WidgetFooter.vue?vue&type=template&id=d63cdb74&scoped=true&"
import script from "./WidgetFooter.vue?vue&type=script&lang=js&"
export * from "./WidgetFooter.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFooter.vue?vue&type=style&index=0&id=d63cdb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63cdb74",
  null
  
)

export default component.exports